<div class="container-fluid">
  <button mat-raised-button color="primary" (click)="showNavigation()">{{ (!navigation ? 'GENERAL.SHOW_NAVIGATION' : 'GENERAL.HIDE_NAVIGATION') | translate }}</button>
  <button mat-raised-button color="primary" style="margin-left: 10px; margin-bottom: 10px" (click)="showPlotsMode()">{{ (!showPlots ? 'GENERAL.SHOW_GRAPHICS' : 'GENERAL.HIDE_GRAPHICS') | translate }}</button>
  <div class="row" [hidden]="!navigation">
    
    <div *ngIf="!tab?.isRoot(); else root" class="col-12 cabeceraSelect">
      <div class="row volver">
        <app-svg
          (click)="onGoBack(tab?.parent)"
          class="icon-arrow-left pointer margen"
          name="arrow-left"
        >
        </app-svg>
        <div class="margen styleGoOnBack">
          {{ "GENERIC.BACK_TO" | translate }} {{ tab?.parent?.name }}
        </div>

        <button
          *ngIf="tab?.navegationStack.length > 0"
          mat-button
          class="dropdown menuStack"
          [matMenuTriggerFor]="menu"
        >
          <app-svg name="dropdown"></app-svg>
        </button>
        <mat-menu #menu="matMenu" class="stackMenu">
          <div
            *ngFor="let item of tab?.navegationStack.reverse(); let i = index"
          >
            <button
              class="stackButton"
              (click)="stackNavigation(item, i)"
              mat-menu-item
            >
              {{ item?.name }}
            </button>
          </div>
        </mat-menu>
      </div>
      <div class="row nameStyle titleStyle">
        <div *ngIf="!editMode" (click)="activeEdition()" class="cell">
          <h2>{{ tab?.currentDeviceDetail?.name }}</h2>
        </div>
        <input
          *ngIf="editMode"
          (focusout)="onFocusOut()"
          (keydown.enter)="blurEvent($event)"
          [(ngModel)]="tab.currentDeviceDetail.name"
          class="cellInput"
          type="text"
          id="editDeviceName"
          (keydown.enter)="blurEvent($event)"
        />
      </div>
    </div>
  </div>

  <ng-template #root>
    <div class="nameStyle w100">
      <div class="row titleStyle">
        <div *ngIf="!editMode" (click)="activeEdition()" class="cell">
          <h2>{{ tab?.currentDeviceDetail?.name }}</h2>
        </div>
        <input
          *ngIf="editMode"
          (focusout)="onFocusOut()"
          (keydown.enter)="blurEvent($event)"
          [(ngModel)]="tab.currentDeviceDetail.name"
          class="cellInput"
          type="text"
          id="editDeviceName"
          (keydown.enter)="blurEvent($event)"
          (focusout)="editMode = false"
        />
      </div>
    </div>
  </ng-template>

  <!-- <div class="row-device-details">
    <app-device-detail
      [deviceDetail]="tab.currentDeviceDetail.info.consumptionInfo"
      (back)="onGoBack($event)"
    >
    </app-device-detail>
  </div> -->
  <div class="row graficas">
    <div class="col-md-3 col-xs-6 col-lg-3" *ngIf="navigation">
      <div class="cardDispositivos card-body withoutPadding" >
        <app-device-detail-list
          [title]="title"
          [deviceChildrenList]="tab?.currentDeviceDetail?.children"
          (deviceItemNavegate)="navigate($event)"
          (deviceItemSelected)="selectedDeviceGraphItem($event)"
          [loadingChildren]="loading"
        >
        </app-device-detail-list>
      </div>
    </div>

    <div
      *ngFor="let plotlyChart of plotlyChartCollection; let i = index"
      class="col-md-4 col-xs-12 col-lg-4"
    >
      <div class="card deviceGraphic minHeight" *ngIf="showPlots">
        <div *ngIf="!loadingChart; else showSpinnerChart" class="card-body">
          <h3>{{ plotlyChart?.layoutChart?.title }}</h3>
          <app-plotly
            [plotlyChartCollection]="plotlyChart.dataChart"
            [width]="580"
            [height]="500"
            [isDeviceSection]="true"
            [unity]="plotlyChart?.dataChart[0]?.unity"
          ></app-plotly>
        </div>
      </div>
    </div>
  </div>
  <ng-template #showSpinner>
    <app-loading [loadingText]="loadingText"></app-loading>
  </ng-template>

  <ng-template #showSpinnerChart>
    <app-loading [loadingText]="loadingChartText"></app-loading>
  </ng-template>
</div>
